'use client';

import Divider from '../../dashboard/components/article-elements/Divider';
import styles from '../../page.module.scss';
import ShareIcons from '../static-sections/ShareIcons';
import { useEffect, useState } from 'react';

interface OneArticleProps {
  article: any;
}

const OneArticle: React.FC<OneArticleProps> = ({ article }) => {
  const dynamicContent = article?.dynamicContent.filter(
    (element: any) =>
      !element.published && !element.activitieDate && element.publishedDate === undefined
  );

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const extractYouTubeID = (url: string): string | null => {
    if (!url || typeof url !== 'string') return null;

    url = url.trim();

    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/|youtube\.com\/watch\?.*&v=)([^#&?]*)/,
      /^([a-zA-Z0-9_-]{11})$/, // Si solo es el ID
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match && match[1] && match[1].length === 11) {
        return match[1];
      }
    }

    return null;
  };

  return (
    <div className={`${styles.mainContainer} ${isVisible ? styles.visible : ''}`}>
      <img className={styles.oneArticleMainImage} src={article.mainImage} alt="" />
      <header className={styles.oneArticleHeader}>
        <h1 className={styles.oneArticleTitle}>{article.mainTitle}</h1>
        <p>{article.publishedDate}</p>
        <ShareIcons />
      </header>
      <main className={styles.oneArticleContentContainer}>
        {dynamicContent &&
          dynamicContent.map((element: any, index: number) => {
            const videoId = element.videoContent ? extractYouTubeID(element.videoContent) : null;

            return (
              <div className={styles.oneArticleContent} key={element.id || index}>
                {element.textContent && (
                  <div
                    style={{ marginTop: '1rem' }}
                    dangerouslySetInnerHTML={{ __html: element.textContent }}
                  />
                )}

                {element.titleContent && <h2>{element.titleContent}</h2>}

                {element.imageContent && (
                  <img style={{ marginBlock: '1rem' }} src={element.imageContent} alt="" />
                )}

                {element.videoContent && element.videoContent !== '' && (
                  <div className={styles.oneArticleVideoContainer}>
                    {videoId && videoId !== '' ? (
                      <iframe
                        className={styles.oneArticleVideo}
                        src={`https://www.youtube.com/embed/${videoId}`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe>
                    ) : (
                      <></>
                    )}
                  </div>
                )}

                {element.divider === true && (
                  <div style={{ maxWidth: '800px' }}>
                    <Divider />
                  </div>
                )}
              </div>
            );
          })}
      </main>
    </div>
  );
};

export default OneArticle;
